import React from 'react'
import styled from 'styled-components'
import Produtos from './Produtos'

const GridView = ({ produtos }) => {
  return (
    <Wrapper>
      <div className='produtos-container'>
        {produtos.map((produtos) => {
          return <Produtos key={produtos.id} {...produtos} />
        })}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  img {
    height: 175px;
  }

  .produtos-container {
    display: grid;
    gap: 2rem 1.5rem;
  }

  @media (min-width: 992px) {
    .produtos-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (min-width: 1170px) {
    .produtos-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`

export default GridView
